import React, { useEffect, useRef } from 'react';

// ⚠️ REPLACE with your actual Google Form embed URL
const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSd0eTU2oThhx6JpMwtm2HbPT2-QSu5wt4ZV28gl6joMl7ZknQ/viewform?embedded=true';

// https://docs.google.com/forms/d/e/1FAIpQLSd0eTU2oThhx6JpMwtm2HbPT2-QSu5wt4ZV28gl6joMl7ZknQ/viewform?usp=publish-editor


const CONTACT_INFO = [
  {
    icon: '📍',
    label: 'Address',
    value: 'Amrut Complex 2nd floor, Opp. Royal Stationary, Anand Banglows chowk, Mavdi mainroad, Rajkot – 360004, Gujarat, India',
  },
  {
    icon: '📞',
    label: 'Phone',
    value: '+91 90817 95075',
    href: 'tel:+919081795075',
  },
  {
    icon: '✉️',
    label: 'Email',
    value: 'bsmbhojansevamandalfoundation@gmail.com',
    href: 'mailto:bsmbhojansevamandalfoundation@gmail.com',
  },
  {
    icon: '🕐',
    label: 'Working Hours',
    value: 'Mon–Sun: 6:00 AM – 8:00 PM\n(Kitchen open daily)',
  },
];

export default function Contact() {
  const ref = useRef(null);
  useEffect(() => { if (ref.current) ref.current.classList.add('page-enter'); }, []);

  return (
    <div ref={ref} className="pt-20">
      {/* Page header */}
      <section className="bg-amber-900 py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'radial-gradient(circle, #f97316 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }} />
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <div className="font-hindi text-orange-400 text-xl mb-4">संपर्क करें</div>
          <h1 className="font-display text-5xl md:text-6xl text-amber-50 mb-6">Get In Touch</h1>
          <p className="text-amber-300 text-lg max-w-xl mx-auto">
            Whether you want to volunteer, partner with us, or simply know more about our work — we'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact grid */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-14">
          {/* Contact info */}
          <div>
            <div className="lotus-divider text-left mb-4">🪷 🪷</div>
            <h2 className="section-title">Contact Details</h2>
            <p className="text-amber-700 mb-10 leading-relaxed">
              Our office and main kitchen are located in Rajkot. You're always welcome to visit during working hours to meet the team, see the operations, or drop off donations in kind.
            </p>

            <div className="space-y-6">
              {CONTACT_INFO.map(({ icon, label, value, href }) => (
                <div key={label} className="card p-5 flex gap-4 items-start">
                  <div className="text-2xl flex-shrink-0 mt-0.5">{icon}</div>
                  <div>
                    <div className="text-xs text-amber-500 uppercase tracking-widest mb-1">{label}</div>
                    {href ? (
                      <a href={href} className="text-amber-900 font-medium hover:text-orange-600 transition-colors whitespace-pre-line">
                        {value}
                      </a>
                    ) : (
                      <p className="text-amber-900 font-medium whitespace-pre-line">{value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Social / WhatsApp */}
            <div className="mt-10">
              <div className="text-xs text-amber-500 uppercase tracking-widest mb-4">Also reach us on</div>
              <div className="flex gap-3">
                <a
                  href="https://wa.me/9081795075"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-green-600 text-white px-5 py-2.5 rounded-sm text-sm font-medium hover:bg-green-700 transition-colors"
                >
                  <span>💬</span> WhatsApp
                </a>
                {/* <a
                  href="https://facebook.com/bhojansevamandal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-blue-700 text-white px-5 py-2.5 rounded-sm text-sm font-medium hover:bg-blue-800 transition-colors"
                >
                  <span>📘</span> Facebook
                </a> */}
              </div>
            </div>

            {/* Volunteer note */}
            <div className="mt-10 p-6 bg-orange-50 border-l-4 border-orange-500 rounded-sm">
              <h3 className="font-display text-xl text-amber-900 mb-2">Want to Join Food Campaigns?</h3>
              <p className="text-amber-700 text-sm leading-relaxed">
                {/* We welcome volunteers every morning from 6 AM for kitchen prep and distribution. No prior experience needed — just a warm heart and willingness to serve. Fill the form opposite to register your interest. */}
                Members get priority invites to volunteer at our quarterly food distribution campaigns. No prior experience needed — just a warm heart and willingness to serve. Fill the form opposite to register your interest or contact us for campaign schedules.
              </p>
            </div>
          </div>

          {/* Google Form embed */}
          <div>
            <div className="lotus-divider text-left mb-4">🪷 🪷</div>
            <h2 className="section-title">Send Us a Message</h2>
            <p className="text-amber-700 mb-6 leading-relaxed">
              Use the form below to reach out. We respond within 24 hours.
            </p>

            <div className="bg-white rounded-sm shadow-md overflow-hidden border border-amber-100">
              {/* Decorative top bar */}
              <div className="h-2 bg-gradient-to-r from-orange-500 via-amber-500 to-orange-400" />
              
              {/* Google Form iFrame */}
              <div className="relative">
                <iframe
                  src={GOOGLE_FORM_URL}
                  width="100%"
                  height="680"
                  frameBorder="0"
                  marginHeight="0"
                  marginWidth="0"
                  title="Contact Form"
                  className="block"
                  style={{ background: '#fff' }}
                >
                  Loading form…
                </iframe>
              </div>

              {/* Fallback note */}
              <div className="px-6 pb-4 bg-amber-50 border-t border-amber-100">
                <p className="text-xs text-amber-500 mt-3">
                  ⚠️ If the form does not load, please write to us at{' '}
                  <a href="mailto:bsmbhojansevamandalfoundation@gmail.com" className="underline hover:text-orange-600">
                    bsmbhojansevamandalfoundation@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map placeholder */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="section-title text-center mb-8">Find Us</h2>
          <div className="rounded-sm overflow-hidden shadow-md border border-amber-100 h-80">
            <iframe
              src="https://maps.google.com/maps?q=Amrut%20Complex%202nd%20floor,%20Opp.%20Royal%20Stationary,%20Anand%20Banglows%20Chowk,%20Mavdi%20Main%20Road,%20Rajkot%20360004,%20Gujarat,%20India&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Location Map"
            />
          </div>
          <p className="text-center text-amber-500 text-sm mt-4">
            Amrut Complex 2nd floor, Opp. Royal Stationary, Anand Banglows chowk, Mavdi mainroad, Rajkot – 360004, Gujarat, India
          </p>
        </div>
      </section>
    </div>
  );
}
